import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';
import ProductList from '../components/ProductList';
import VariantHelper from '../utils/VariantHelper';
import ImageZoom from '../components/ImageZoom';
import Select from '../components/Select';
import Rte from '../utils/Rte';

function updateCart() {
  window.Shopify.getCart((cart) => {
    const newFormattedAmount = window
      .Shopify
      .formatMoney(cart.total_price, window.Theme.moneyFormat);

    // Update cart text
    $('.cart-item-count-wrap').text(`(${cart.item_count})`);
    const $newAmount = $('.cart-amount-wrap').html(newFormattedAmount);

    if (CurrencyConverter.isInitialised) {
      CurrencyConverter.update($newAmount[0]);
    }
  });
}

export default class Product {
  constructor(section) {
    this.el = section.el;
    this.data = section.data;
    this.product = this.data.product;

    try {
      this.enableZoom = this.data.enable_zoom;
      this.enableRelatedProducts = this.data.enable_related_products;

      this.addingToCart = false;

      this.$productArea = $('.product-page', this.el);
      this.$productThumbnails = $('.product-image-thumbnails img', this.$productArea);
      this.$productForm = $('.product-form', this.$productArea).eq(0);
      this.$priceArea = $('.product-price', this.$productForm);
      this.$addToCartButton = $('.product-add input', this.$productForm);
      this.$variantDropdowns = $('[data-option-select]', this.$productForm);

      this.options = this.product.options;
      this.variants = this.product.variants;
      this.images = this.product.images;

      if ($('.product-form', this.el).length) {
        this.setupVariants();
      }

      if (this.enableRelatedProducts) {
        this.relatedView = new ProductList({ el: this.el.querySelector('.related-products') });
      }

      if (this.enableZoom) {
        this.zoomView = new ImageZoom(this.el.querySelector('.product-main-image'));
      }

      $('select', this.el).each((index, select) => new Select({ el: select }));

      $('.rte', this.el).each((index, rte) => new Rte({ el: rte }));

      window.Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);

      this.$productThumbnails.on('click.product', event => this.switchProductImage(event));
      this.$addToCartButton.on('click.product', event => this.addToCart(event));

      this.images = JSON.parse($('[data-images]', this.el).text());
    } catch (e) {
      console.error(e);
    }
  }

  setupVariants() {
    if (!this.$variantDropdowns.length) { return; }

    const dropdownSettings = {
      $addToCartButton: this.$addToCartButton,
      $priceFields: this.$priceArea,
      $productForm: this.$productForm,
      $productThumbnails: this.$productThumbnails,
      $selector: this.$variantDropdowns,
      productSettings: this.data,
      productJSON: this.product,
      type: 'select',
    };

    this.variantHelpers = new VariantHelper(dropdownSettings);
  }

  switchProductImage(e) {
    if (this.enableZoom) {
      this.zoomView.unload();
    }

    const imageId = $(e.target, this.el).data('image-id');

    const imageVariant = $(e.target, this.el).closest('[data-variant-title]').data('variant-title').split(' / ');

    const $nextImage = $(this.images[imageId]);
    $nextImage.css('display', 'none');

    const $image = $('[data-product-main-image]', this.el);

    $nextImage.one('load', () => {
      $('.product-main-image', this.el).children().not($nextImage).remove();
      $nextImage.css('display', '');

      if (this.enableZoom) {
        this.zoomView = new ImageZoom(this.el.querySelector('.product-main-image'));
      }
    });
    $image.after($nextImage);
    $nextImage.trigger('theme:rimg:watch');

    this.$variantDropdowns.each((index, el) => {
      const optionIndex = $(el).data('option-index');
      const selection = imageVariant[optionIndex];

      $(el).find(`option[value="${selection}"]`).prop('selected', true);
    });

    this.variantHelpers.updateVariantFromImage(imageVariant);
  }

  addToCart(e) {
    if (this.data.enable_cart_redirection) {
      return;
    }

    e.preventDefault();

    $('.product-message-wrapper', this.el).remove();
    if ((this.addingToCart === true) || (this.$productForm.serialize() === '')) {
      return;
    }

    const $button = $('.product-add .action-btn', this.el);

    if (!$button.hasClass('disabled')) {
      this.addingToCart = true;

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: this.$productForm.serialize(),
        dataType: 'json',
        success: () => {
          const message = this.data.atc_message_success
            .replace('{{ product }}', `${this.product.title}`)
            .replace('{{ cart_link }}', `<a href='/cart'>${this.data.atc_cart_link}</a>`)
            .replace('{{ continue_link }}', `<a href='/collections/all'>${this.data.atc_continue_shopping}</a>`)
            .replace('{{ checkout_link }}', `<a href='/checkout'>${this.data.atc_checkout_link}</a>`);

          setTimeout(() => {
            $('.product-add-to-cart', this.el).append(`
                <li class="product-message-wrapper"><p class="product-message">${message}</p></li>
              `)
              .addClass('success-message').removeClass('error-message');
            this.addingToCart = false;
            updateCart();
          },
          500);
        },
        error: error => this.handleErrors(error),
      });
    }
  }

  handleErrors(error) {
    setTimeout(() => {
      $('.product-add-to-cart', this.el)
        .append(`
          <li class="product-message-wrapper">
              <p class="product-message">
                  ${error.responseJSON.description}
              </p>
          </li>
        `)
        .addClass('error-message')
        .removeClass('success-message');
      this.addingToCart = false;
    },
    1000);
  }

  onSectionSelect() {
    if (!this.variantHelpers && CurrencyConverter.isInitialised) {
      $('.money', this.el).each((index, money) => CurrencyConverter.update(money));
    }
  }

  onSectionUnload() {
    if (this.zoomView != null) {
      this.zoomView.unload();
    }

    if (this.relatedView) {
      this.relatedView.unload();
    }

    this.$productThumbnails.off('click.product');
    this.$addToCartButton.off('click.product');
  }
}
